/**
 * @Author proudlx
 * @Description http请求方法
 */
import request from "@/api/http/request";
import { POST_BASE_DICT_LIST } from "@/api/apiConst";

// 类型定义
export interface dictItemType {
  createDate?: string;
  description?: string;
  id?: string;
  label: string;
  parentId?: string;
  remarks?: string;
  sort?: number;
  type?: string;
  updateDate?: string;
  value: string;
  status?: number;
  /** 类型别名 */
  otherName?: string;
  businessId?: string;
}

/** 字典列表请求 */
export function getDictList(data: { type: string }) {
  return request.post<dictItemType[]>(POST_BASE_DICT_LIST, data);
}
